import { render, staticRenderFns } from "./addActivateCode.vue?vue&type=template&id=30b8aa4d&scoped=true&"
import script from "./addActivateCode.vue?vue&type=script&lang=js&"
export * from "./addActivateCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b8aa4d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\drone_race_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30b8aa4d')) {
      api.createRecord('30b8aa4d', component.options)
    } else {
      api.reload('30b8aa4d', component.options)
    }
    module.hot.accept("./addActivateCode.vue?vue&type=template&id=30b8aa4d&scoped=true&", function () {
      api.rerender('30b8aa4d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/divisionManage/divisionAllController/component/addActivateCode.vue"
export default component.exports